import { H2 } from "@carrotfertility/carotene"
import React from "react"
import L10n from "../../../lib/carrot-l10n"
const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export const MerchantDeclineLoading = () => (
  <div>
    <div className="tc pt5">
      <H2 variant="dark">{l`Still loading, just a moment…`}</H2>
    </div>

    <div className="flex justify-center items-center h-100">
      <div className="lds-ellipsis">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  </div>
)
